import React, { useState } from 'react';
import { X } from 'lucide-react';
import { galleriaImages, siteInfo } from '../data/mock';

const GalleriaSection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div 
      className="min-h-screen pt-20 pb-12 bg-cover bg-center bg-fixed relative"
      style={{
        backgroundImage: `url('${siteInfo.dashboardImage}')`
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-white/90" />
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8">
        {/* Title */}
        <div className="mb-12 text-center">
          <h2 className="font-cinzel text-2xl md:text-3xl font-semibold text-amber-800 tracking-wide">
            Galleria
          </h2>
          <div className="w-24 h-0.5 bg-amber-700 mt-4 mx-auto" />
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleriaImages.map((image) => (
            <button
              key={image.id}
              onClick={() => setSelectedImage(image)}
              className="relative aspect-square rounded-xl overflow-hidden border-2 border-amber-200 shadow-md hover:shadow-xl transition-all group"
            >
              <img 
                src={image.src} 
                alt={image.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              {/* Watermark Logo */}
              <div className="absolute bottom-2 left-2 opacity-70">
                <img 
                  src={siteInfo.logoFull} 
                  alt="ARKI"
                  className="h-8 md:h-10 w-auto drop-shadow-lg"
                  style={{ filter: 'drop-shadow(0 0 2px rgba(255,255,255,0.8))' }}
                />
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 p-2 bg-white/20 rounded-full hover:bg-white/30 transition-colors"
          >
            <X className="w-6 h-6 text-white" />
          </button>
          <div className="relative max-w-full max-h-[80vh]">
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="max-w-full max-h-[80vh] rounded-xl object-contain shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
            {/* Watermark on Lightbox */}
            <div className="absolute bottom-4 left-4 opacity-80">
              <img 
                src={siteInfo.logoFull} 
                alt="ARKI"
                className="h-12 md:h-16 w-auto drop-shadow-lg"
                style={{ filter: 'drop-shadow(0 0 3px rgba(255,255,255,0.9))' }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleriaSection;
